import { render, staticRenderFns } from "./multi-campaign.vue?vue&type=template&id=79ca32c6"
import script from "./multi-campaign.vue?vue&type=script&lang=js"
export * from "./multi-campaign.vue?vue&type=script&lang=js"
import style0 from "./multi-campaign.vue?vue&type=style&index=0&id=79ca32c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports